<script>
    import {mapState, mapActions, mapGetters} from 'vuex'

    export default {
        props: {},
        data() {
            return {}
        },
        methods: {},
        computed: {
            ...mapGetters('user/menu', {
                links: 'items',
            })
        },
        watch: {},
        mounted() {
        },
        components: {},
    }
</script>
<template>
    <div class="mag-nav">
        <div class="mag-nav__logo"></div>
        <div class="mag-nav__menu">
            <template v-for="link in links">
                <template v-if="link.link">
                    <router-link v-if="link.spa" class="nav-link" :class="{min: link.min}" :to="link.spa">
                        <i :class="link.icon"></i>
                        <span>{{link.name}}</span>
                    </router-link>
                    <a v-if="link.href" class="nav-link" :class="{min: link.min}" :href="link.href">
                        <i :class="link.icon"></i>
                        <span>{{link.name}}</span>
                    </a>
                </template>
                <template v-else>
                    <span class="nav-link" :class="{min: link.min}">
                        <i :class="link.icon"></i>
                        <span>{{link.name}}</span>
                    </span>
                </template>
            </template>
        </div>
        <div class="mag-nav__button">
            <i class="mag-icon-nav-arrow"></i>
        </div>
    </div>
</template>
<style lang="scss">
    .mag-nav {
        &__logo {
            width: 100%;
            height: 100px;
            background: url(/tourclient/agency/logo) 50% 50% no-repeat;
        }
        &__menu {
            width: 100%;
            height: calc(100% - 150px);
            overflow-y: auto;
            overflow-x: hidden;
            &::-webkit-scrollbar {
                width: 8px;
                position: absolute;
            }
            &::-webkit-scrollbar-track {
                background: none;
            }
            &::-webkit-scrollbar-thumb {
                background-color: rgba(0, 0, 0, 0.3);
            }
            &::-webkit-scrollbar-thumb:hover {
                background-color: rgba(0, 0, 0, 0.5);
            }
        }
        &__button {
            width: 100%;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            i {
                transform: rotate(-90deg);
                display: inline-block;
                border: 2px solid;
                border-radius: 50%;
                padding: 4px;
            }
        }
    }

    .nav-link {
        width: 100%;
        line-height: 49px;
        padding: 0 0 0 16px;
        margin: 0;
        text-transform: uppercase;
        text-decoration: none;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #253e4a;
        &.min {
            line-height: 39px;
            border-bottom: none;
            i{
                color: #dfca4d;
            }
        }
        i {
            font-size: 20px;
            width: 26px;
        }
    }
    .login{
        .mag-nav{
            &__logo {
                display: none;
            }
            &__menu{
                height: calc(100% - 60px);
                background: #2e4e5d;
            }
            &__button{
                height: 60px;
                background: #253e4a;
                color: #fff;
            }
        }
        .nav-link{
            display: block;
            width: 100%;
            height: 80px;
            border-bottom: 1px solid #253e4a;
            text-align: center;
            text-decoration: none;
            color: #fff;
            padding: 0 8px;
            transition: .2s all;
            font-weight: 300;
            font-size: 11px;
            i {
                font-size: 30px;
            }
            span {
                display: block;
                line-height: 1.8;
                text-transform: uppercase;
            }
        }
    }
</style>